import css from 'styled-jsx/css';

const styles = css.global`.alerts{position:fixed;right:0;top:6.25rem;width:100%;max-width:18.75rem}.alerts.bottom{top:unset;bottom:6.25rem}`;

export default styles;